import {formatTime} from "../utils/formatTime";

window.ConversationPreview = {
    init(conversationUuid) {
        this.formatLastUpdate(conversationUuid)
    },

    formatLastUpdate(conversationUuid) {
        const lastUpdateTime = document.getElementById(`last-update-time-${conversationUuid}`).value;
        const lastUpdateElement = document.getElementById(`last-update-${conversationUuid}`);
        const timestamp = new Date(lastUpdateTime).getTime();
        lastUpdateElement.textContent = `${formatTime(timestamp)}`;
    }
};
